// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__AqByH","container":"DefaultLayout_container__iXLx9","content":"DefaultLayout_content__-uoxC","wide":"DefaultLayout_wide__GkbTg"};